import pluralize from "pluralize";
import React from "react";

import dayjs from "../../shared/helpers/dayjs";

const avoMapper = addedValueOffers => addedValueOffers.map(avo => (
  <li key={avo.id}>
    <i className="fa fa-tags fa-li" aria-hidden="true"></i> {avo.description}
  </li>
));

const expiresText = daysLeft => (
  <span className="venue__offer__expiry"> ({
    daysLeft < 1
      ? "Ends today!"
      : `${pluralize("day", daysLeft, true)} to go`
    })
  </span>
);

const arrivalItem = (date, formattedDate) => {
  const daysLeft = dayjs(date).diff(dayjs(), "days");
  const isExpiringSoon = daysLeft >= 0 && daysLeft <= 3;

  return (
    <li>
      <i className="fa fa-calendar fa-li" aria-hidden="true"></i> Arriving on <strong>{formattedDate}</strong>
      {isExpiringSoon && expiresText(daysLeft)}
    </li>
  );
};

const golfersText = paxOptions => paxOptions
  .sort()
  .map(pax => pluralize("golfer", pax, true))
  .join(" or ");

const roundsByCourseMapper = roundsByCourse => Object.keys(roundsByCourse).map(course => (
  <li key={course}>
    <i className="fa fa-flag fa-li" aria-hidden="true"></i> {pluralize("round", roundsByCourse[course], true)} at <strong>{course}</strong>
  </li>
));

const listItems = ({
  addedValueOffers,
  boardBasis,
  date,
  formattedDate,
  paxOptions,
  roundsByCourse
}) => (
  <ul className="icon-list icon-list--yellow">
    {arrivalItem(date, formattedDate)}

    <li>
      <i className="fa fa-male fa-li" aria-hidden="true"></i> {golfersText(paxOptions)}
    </li>

    <li>
      <i className="fa fa-bed fa-li" aria-hidden="true"></i> {boardBasis}
    </li>

    {roundsByCourseMapper(roundsByCourse)}

    {avoMapper(addedValueOffers)}
  </ul>
);

const OfferSummary = props => (
  <div className="venue__offer__content">
    {listItems(props)}
  </div>
);

export default OfferSummary;



// WEBPACK FOOTER //
// ./components/last_minute_deals/OfferSummary.jsx